export default "__VITE_ASSET__DAV9lkPv__"